export default __webpack_public_path__ + "static/media/light_blue_waves.57b6ed6e.svg";